<template>
    <div class="c-location-modal" v-if="selectedMarker">
        <div v-if="selectedMarker && selectedMarker.courses && selectedMarker.courses.length"
            class="c-location-modal__content">
            <div v-for="group in groupedCourses" :key="group.institution" class="c-location-modal__institution">
                <h3 class="c-location-modal__institution-name">{{ group.institution }}</h3>
                <ul class="c-location-modal__course-list">
                    <li v-for="course in group.courses" :key="course.id" class="c-location-modal__course-item">
                        <a :href="course.link">{{ course.title }}</a>
                    </li>
                </ul>
            </div>

        </div>
        <button @click="closeModal" class="c-square-button c-location-modal__close">
            <svg class="icon icon-close">
                <use xlink:href="#icon-close"></use>
            </svg>
        </button>
    </div>
</template>

<script setup>
import { computed } from 'vue';


const props = defineProps({
    selectedMarker: Object,
    selectedFilters: Object,
});

const selectedMarker = defineModel('selectedMarker');

const selectedDiscipline = computed(() => {
    return props.selectedFilters ? (props.selectedFilters.discipline || '') : '';
});

const groupedCourses = computed(() => {
    if (!selectedMarker.value || !selectedMarker.value.courses) return [];

    let courses = selectedMarker.value.courses || [];

    if (selectedDiscipline.value) {
        courses = courses.filter((course) => {
            const discs = course.discipline;
            if (!discs) return false;
            if (Array.isArray(discs)) {
                return discs.some(d => d && d.slug === selectedDiscipline.value);
            }
            return false;
        });
    }

    const groups = {};

    courses.forEach((course) => {
        const inst = course.institution;
        let name = '';

        if (!inst) {
            name = '';
        } else {
            name = inst.name;
        }

        if (!groups[name]) groups[name] = [];
        groups[name].push(course);
    });

    return Object.keys(groups).map((institution) => ({ institution, courses: groups[institution] }));
});

const closeModal = () => {
    selectedMarker.value = null;
};
</script>

<style scoped></style>
